import React from 'react'
import { CompactLayoutContext } from '../compactLayout/CompactLayoutContext'
import classNames from 'classnames'

import styles from './AgentFooter.module.scss'

export interface AgentFooterProps {
  className?: string
}

export const AgentFooter: React.FC<React.PropsWithChildren<AgentFooterProps>> = ({
  children,
  className,
}) => {
  const { layoutState } = React.useContext(CompactLayoutContext)
  return (
    <div
      className={classNames(
        styles.root,
        layoutState === 'compact' ? styles['root-overhanging'] : undefined,
        className,
      )}
    >
      {children}
    </div>
  )
}
